import React from 'react';
import { useTranslation } from 'react-i18next';

import Grid from '@mui/material//Unstable_Grid2';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import { styled, useTheme } from '@mui/material';

import { GenderType, UserInfoT } from 'business/definitions';
import { capitalize } from 'helpers/helpers';
import { USER_CREATION_FORM_ACTION_TYPE } from '../../../CreateUserContext/types';
import {
    useUserCreationFormContext,
    useUserCreationFormDispatchContext,
} from '../../../CreateUserContext/CreateUserFormContext';

const StyFormControl = styled(FormControl)(({ theme }) => ({
    marginBottom: theme.spacing(2),
}));

const StyTextField = styled(TextField)(({ theme }) => ({
    '& .MuiInputBase-root': {
        backgroundColor: theme.palette.background.paper,
    },
    '& .MuiFormLabel-asterisk': { color: theme.palette.red },
}));

const orderedUserPersonalInformation = [
    'firstname',
    'lastname',
    'email',
    'job',
];

const PersonalInformationSection = (): JSX.Element => {
    const { t } = useTranslation();
    const theme = useTheme();
    const userCreationForm = useUserCreationFormContext();
    const { dispatchUserCreationForm } = useUserCreationFormDispatchContext();

    const { gender } = userCreationForm;

    return (
        <div style={{ marginBottom: theme.spacing(5) }}>
            <StyFormControl>
                <RadioGroup
                    row
                    name="gender"
                    onChange={(event) => {
                        dispatchUserCreationForm({
                            type: USER_CREATION_FORM_ACTION_TYPE.updateGender,
                            gender: event.target.value as GenderType,
                        });
                    }}
                    value={gender}
                >
                    <FormControlLabel
                        control={<Radio />}
                        label="Madame"
                        value="F"
                    />
                    <FormControlLabel
                        control={<Radio />}
                        label="Monsieur"
                        value="M"
                    />
                </RadioGroup>
            </StyFormControl>
            <Grid container spacing={2}>
                {orderedUserPersonalInformation.map(
                    (personalInformation: keyof Omit<UserInfoT, 'gender'>) => (
                        <Grid key={personalInformation} xs={6}>
                            <StyTextField
                                fullWidth
                                label={capitalize(
                                    t(`common.${personalInformation}`),
                                )}
                                name={personalInformation}
                                onChange={(event) => {
                                    dispatchUserCreationForm({
                                        type: USER_CREATION_FORM_ACTION_TYPE.updatePersonalInformation,
                                        payload: {
                                            [personalInformation]:
                                                event.target.value,
                                        },
                                    });
                                }}
                                required
                                value={userCreationForm[personalInformation]}
                                variant="outlined"
                            />
                        </Grid>
                    ),
                )}
            </Grid>
        </div>
    );
};

export default PersonalInformationSection;
